import React, { useEffect, useState } from "react";
import {  putData } from '../../../../services/library';
import { Typography, Grid, Box, Card, TextField,  CardContent, Dialog, DialogTitle, Button } from "@mui/material";
import moment from "moment";
import { logEventos } from "../../../../services/services";
import Notify from "../../../Notify";

export default function Editar_lista(props) {
    const { datosExisten, open } = props;
    const [datosForm, setdatosForm] = useState(datosExisten);

    const style = {
        backgroundColor: "#ffffff",
        width: "100%",
    };

    const [notificacion, setNotificacion] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
    });

    const almacenar = (event) => {
        const { name, value } = event.target;

        // Guardamos el valor directamente para que se vea lo que escribe el usuario (aunque no sea número aún)
        let newValue = { ...datosForm, [name]: value };


        // Si llegó hasta acá, significa que el valor es válido para cálculos
        const valorNormalizado = value.replace(',', '.');
        const floatValue = parseFloat(valorNormalizado);

        if (isNaN(floatValue)) {
            setdatosForm(newValue); // Si aún no se puede parsear, no hacemos cálculos
            return;
        }

        const densidad =
            datosForm && datosForm.id_empresa === 1
                ? datosForm.densidad_hipergas
                : datosForm.densidad_autogas;

        const truncar = (num) => {
            return Number(num).toFixed(2).replace('.', ',');
        };

        if (value === "") {
            setdatosForm({
                ...datosForm,
                lt_sin_iva: "",
                lt_con_iva: "",
                kg_sin_iva: "",
                kg_con_iva: "",
                [name]: "",
            });
            return;
        }

        // Lógica de cálculos
        if (name === "lt_sin_iva") {
            const precioConIva = floatValue * datosForm.valor;
            const kgConIva = precioConIva / densidad;
            const kgSinIva = kgConIva / datosForm.valor;
            newValue.kg_sin_iva = truncar(kgSinIva);
            newValue.lt_con_iva = truncar(precioConIva);
            newValue.kg_con_iva = truncar(kgConIva);

        }

        if (name === "kg_sin_iva") {
            const precioConIva = floatValue * datosForm.valor;
            const ltConIva = precioConIva * densidad;
            const ltSinIva = ltConIva / datosForm.valor;
            newValue.lt_sin_iva = truncar(ltSinIva);
            newValue.kg_con_iva = truncar(precioConIva);
            newValue.lt_con_iva = truncar(ltConIva);

        }

        if (name === "kg_con_iva") {
            const precioSinIva = floatValue / datosForm.valor;
            const ltConIva = precioSinIva / densidad;
            const ltSinIva = ltConIva / datosForm.valor;
            newValue.lt_sin_iva = truncar(ltSinIva);
            newValue.kg_sin_iva = truncar(precioSinIva);
            newValue.lt_con_iva = truncar(ltConIva);
        }

        if (name === "lt_con_iva") {
            const precioSinIva = floatValue / datosForm.valor;
            const kgSinIva = precioSinIva * densidad;
            const kgConIva = kgSinIva * datosForm.valor;

            newValue.kg_con_iva = truncar(kgConIva);
            newValue.lt_sin_iva = truncar(precioSinIva);
            newValue.kg_sin_iva = truncar(kgSinIva);
        }

        setdatosForm(newValue);
    };

    //ESTA FUNCION ES PARA GUARDAR, DEBERIA MODIFICARLA MAS ADELATE PARA HACER UNA TRANSACCION
    const putPrecios = async (e) => {
        putData(e, `/precios_especiales/${datosForm.id_precioespecial}`,
            {
                kg_con_iva: datosForm.kg_con_iva.replace(',', '.'),
                kg_sin_iva: datosForm.kg_sin_iva.replace(',', '.'),
                lt_con_iva: datosForm.lt_con_iva.replace(',', '.'),
                lt_sin_iva: datosForm.lt_sin_iva.replace(',', '.'),
                vigencia: moment(datosForm.vigencia).format("YYYY-MM-DD"),
                usuario: localStorage.getItem('user')
            },
            setNotificacion

        )
        // console.log("datosForm", datosForm);
        logEventos(
            "Editar lista de precios especiales",
            "LISTA DE PRECIOS GRANEL",
            "Actualiza lista de precios especiales ",
            localStorage.getItem("user")
        );
    };

    const handleClose = () => {
        open(false);
        props.actualizar();
        props.tabla(true);
    };

    const formatoParaMostrar = (valor) => {
        if (valor === null || valor === undefined) return '';
        // Si es número, lo paso a string con coma
        if (typeof valor === 'number') {
            return valor.toFixed(2).replace('.', ',');
        }
        // Si es string, reemplazo punto por coma
        return valor.replace('.', ',');
    };

    return (
        <div>
            <Dialog open={open} fullWidth maxWidth="xl" onClose={handleClose}>
                {datosExisten && (
                    <Box sx={{ padding: 2 }}>
                        {/* Card para Precio Vigente */}
                        <Box backgroundColor={"#1F618D"}>
                            <DialogTitle>
                                <Typography variant="h6" align="center" color="#ffffff">
                                    Editar precios de cliente : {datosForm.razon_social}

                                </Typography>
                            </DialogTitle>
                        </Box>
                        <Card variant="outlined" sx={{ mb: 1, backgroundColor: "#F4F6F6" }}>
                            <CardContent>

                                {/* Precios en un solo renglón */}
                                <Grid container spacing={1} alignItems="center" justifyContent="center">
                                    {[
                                        { label: "Precio litro sin IVA", value: datosForm.lt_sin_iva || '', name: "lt_sin_iva" },
                                        { label: "Precio litro con IVA", value: datosForm.lt_con_iva || '', name: "lt_con_iva" },
                                        { label: "Precio kilo sin IVA", value: datosForm.kg_sin_iva || '', name: "kg_sin_iva" },
                                        { label: "Precio kilo con IVA", value: datosForm.kg_con_iva || '', name: "kg_con_iva" },
                                    ].map((item, index) => (
                                        <Grid item xs={12} sm={6} md={2} key={index}>
                                            <TextField
                                                fullWidth
                                                style={style}
                                                focused
                                                size="small"
                                                variant="outlined"
                                                label={item.label}
                                                name={item.name}
                                                value={formatoParaMostrar(item.value)}
                                                onChange={almacenar}
                                            />
                                        </Grid>
                                    ))}
                                    {/* Fechas de Vigencia */}
                                    <Grid item xs={12} sm={6} md={2}>
                                        <TextField
                                            fullWidth
                                            style={style}
                                            focused
                                            size="small"
                                            variant="outlined"
                                            label="Entrada en Vigencia"
                                            value={moment(datosForm.vigencia).format("DD-MM-YYYY") || ""}
                                        />
                                    </Grid>
                                  
                                </Grid>
                                <Grid
                                    container
                                    justifyContent="space-between"
                                    alignItems="flex-end"
                                    mt={2}
                                >
                                    <Button variant="contained"
                                        onClick={() => open(false)}
                                        color="error">
                                        Volver
                                    </Button>

                                    <Button
                                        variant="contained"
                                        type="submit"
                                        color={"success"}
                                        onClick={putPrecios}
                                    >
                                        Actualizar
                                    </Button>
                                </Grid>
                            </CardContent>


                        </Card>
                        {notificacion && notificacion.open ? (
                            <Notify
                                mensaje={notificacion.mensaje}
                                open={notificacion.open}
                                color={notificacion.color}
                                handleClose={handleClose}
                                severity={notificacion.severity}
                            />
                        ) : null}
                    </Box>
                )}
            </Dialog>

        </div>
    )

}